import { h } from 'preact';

export default () => {
  return (
    <div class='openvpn-section step'>
      <h3>Step 2</h3>
      <p>
        Generate an OpenVPN config file. Keep it secure and don't
        share it with others, as it represents your identity.
      </p>
      <p>
        Tunnelblick should have associated with the files when it
        installed. Load the config files by opening them. You can
        also import by drag-and-drop.
      </p>
      <a
        href={`https://${API_ROOT}/auth/signin?action=config`}
        class='button'
        target='_blank'
      >Generate Config</a>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/config/index.js